import { Controller } from 'stimulus'
import './signature_component.css'

// Fills in the handwritten signature in place and enables submit — without shifting the layout.
export default class extends Controller {
  static targets = ['signButton', 'signature', 'submitButton']

  sign() {
    this.signButtonTarget.classList.add('invisible')
    this.signatureTarget.classList.remove('invisible')
    this.signatureTarget.classList.add('signature-writing')
    this.submitButtonTarget.removeAttribute('disabled')
    this.submitButtonTarget.classList.remove('t-btn-disabled')
  }
}
